import { MediaType } from '@repo-level/core-front';
import { Responsive } from 'components/internal/Responsive';
import type { FC } from 'react';
import { Sidebar } from '../Sidebar';
import { TabBar } from '../Tabbar';

export const Nav: FC = () => (
  <Responsive
    desktop={MediaType.DESKTOP_L}
    desktopL={<Sidebar />}
    mobile={<TabBar />}
    mobileS={MediaType.MOBILE}
    tablet={MediaType.DESKTOP_L}
  />
);
